import { EqContext, Query } from '@easyquery/core';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { UserInfo } from '../Login/common/defaults';
import { INameValue } from '../MultiSelect/common';
import MultiSelectList from '../MultiSelect/MultiSelectList';
import { getUserAdminInfo } from '../Administration/redux-objects/actions';
import * as urls from '../shared/urls';
import Api from '../../services/Api';
import { IAdvancedSearchStore } from '../../common/sharedTypes';
import { ApiResponse } from 'apisauce';

interface AdvancedSearchProps {
  query: IAdvancedSearchStore;
  allUsers: UserInfo[];
  getUserAdminInfo: (url: string, active: boolean) => Promise<void>;
  currentUser: UserInfo;
}

interface AdvancedSearchState {
  showShareModal: boolean;
  sharedUsers: number[];
  query: IAdvancedSearchStore;
}

class AdvancedSearchHtml extends React.Component<AdvancedSearchProps, AdvancedSearchState> {
  constructor(props: AdvancedSearchProps) {
    super(props);
    this.state = {
      showShareModal: false,
      sharedUsers: [],
      query: props.query,
    };
  }

  componentDidMount() {
    const { allUsers } = this.props;
    if (allUsers.length === 0) {
      this.props
        .getUserAdminInfo(urls.GET_USER_ADMIN_INFO, true)
        .catch(error => {
          console.error(error);
        });
    }
  }

  componentDidUpdate() {
    if (this.props.query?.id !== this.state.query?.id) {
      console.log('updating query state');
      this.setState({
        query: this.props.query,
        sharedUsers: this.props.query.advancedSearchShares.map(s => s.sharedUserId),
      });
    }
  }

  openShareModal = () => {
    this.setState({
      showShareModal: true,
    });
  }

  closeShareModal = () => (
    this.setState({
      showShareModal: false,
    })
  )

  saveShares = () => {
    Api.post(`${urls.SHARE_QUERY}`, { id: this.props.query.id, userIds: this.state.sharedUsers });

    this.closeShareModal();
  }

  onSharedUserSelect = (_selectedList, selectedItem: INameValue) => {
    this.setState((state) => ({
      sharedUsers: [...state.sharedUsers, parseInt(selectedItem.value)]
    }));
  }

  onSharedUserRemove = (_selectedList, selectedItem: INameValue) => {
    this.setState((state) => {
      return { sharedUsers: state.sharedUsers.filter(s => s.toString() !== selectedItem.value) };
    });
  }

  render() {
    return (
      <>
        <div>
          <div className="eqjs-process-bar" id="ProcessBar"></div>
          <div id="main">
            <div className="eqv-header">
              <div className="eqv-title">Advanced Search</div>
              <div className="eqv-sub-title">Query Builder</div>
            </div>
            <div id="eqv-content">
              <div className="eqv-header-panel">
                <div className="eqv-entities-block">
                  <hr className="eqv-entities-hr eqv-hr" />
                  <div className="eqv-entities-title">Entities</div>
                  <div className="eqv-entities-panel-container">
                    <div id="EntitiesPanel"></div>
                  </div>
                </div>

                <div className="eqv-central-block">
                  <div className="eqv-columns-block">
                    <hr className="eqv-columns-hr eqv-hr" />
                    <div className="eqv-columns-title">Columns</div>
                    <div className="eqv-columns-panel-container">

                      <div id="ColumnsPanel"></div>
                    </div>
                  </div>
                  <div className="eqv-conditions-block">
                    <hr className="eqv-conditions-hr eqv-hr" />
                    <div className="eqv-conditions-title">Conditions</div>
                    <div className="eqv-query-panel-container">

                      <div id="QueryPanel"></div>
                    </div>
                  </div>
                </div>
                <div className="eqv-menu-block">
                  <hr className="eqv-menu-hr eqv-hr" />
                  <div className="eqv-menu-title">Query Menu</div>
                  <div className="eqv-menu-content">

                    <div id="QueryNameLabel"></div>


                    <a id="ClearQueryButton" className="eqv-button">Clear</a>


                    <div className="eqv-dropdown-container">
                      <a id="LoadQueryButton" href="javascript:void(0)" className="eqv-button eqv-drop-button">Load <span style={{ float: "right" }}>▼</span></a>
                      <div className="eqv-dropdown-content">
                      </div>
                    </div>

                    <div className="eqv-dropdown-container">
                      <a id="StorageDropButton" className="eqv-button eqv-drop-button">Storage <span style={{ float: "right" }}>▼</span></a>
                      <div className="eqv-dropdown-content">
                        <a
                          id="NewQueryButton"
                          href="javascript:void(0)"
                        >
                          New query
                        </a>
                        <a
                          id="SaveQueryButton"
                          href="javascript:void(0)"
                          style={{
                            display: this.props.query?.userId === this.props.currentUser.id ? 'inherit' : 'none'
                          }}
                        >
                          Save query
                        </a>
                        <a id="CopyQueryButton" href="javascript:void(0)">Save query as...</a>
                        <a
                          id="RemoveQueryButton"
                          href="javascript:void(0)"
                          style={{
                            display: this.props.query?.userId === this.props.currentUser.id ? 'inherit' : 'none'
                          }}
                        >
                          Remove query
                        </a>
                      </div>
                    </div>

                    <ShareButton
                      id="ShareQueryButton"
                      onClick={() => this.openShareModal()}
                      disabled={this.props.query?.userId !== this.props.currentUser.id}
                    >
                      Share
                    </ShareButton>

                    <a id="FetchDataButton" href="javascript:void(0)" className="eqv-button eqv-button-execute">Fetch data</a>
                  </div>
                </div>
              </div>
              <div className="eqv-bottom-panel">
                <div className="eqv-sql-panel">
                  <hr className="eqv-sql-panel-hr eqv-hr" />
                  <div className="eqv-sql-panel-title">SQL</div>
                  <div id="StatementPanel" className="eqv-sql-block">
                    <div className="sql-panel-result"></div>
                  </div>
                </div>

                <div className="eqv-result-panel">
                  <hr className="eqv-result-panel-hr eqv-hr" />
                  <div className="eqv-result-panel-title">
                    Result
                    <span id="ResultCount" style={{ display: 'none', marginLeft: 20, fontSize: 'small' }}></span>
                    <span className="eqv-export-buttons">
                      <a className="eqjs-export" href="javascript:void(0)" data-format="xlsx">Export to Excel</a>
                      <a className="eqjs-export" href="javascript:void(0)" data-format="csv">Export to CSV</a>
                    </span>
                  </div>
                  <div id="ResultPanel" className="eqv-result-panel-content">
                  </div>
                  <div className="eqv-result-panel-content-padding">
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <Modal show={this.state.showShareModal} onHide={this.closeShareModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Share Search <b>{this.props.query?.name}</b></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MultiSelectList
              title="Users to share with"
              options={this.props.allUsers.map(user => ({ name: `${user.firstName} ${user.lastName}`, value: user.id.toString() }))}
              placeHolder="Select users"
              selections={
                this.props.allUsers
                  .filter(u => this.state.sharedUsers.includes(u.id))
                  .map(u => ({ name: `${u.firstName} ${u.lastName}`, value: u.id.toString() }))
              }
              onSelect={this.onSharedUserSelect}
              onRemove={this.onSharedUserRemove}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeShareModal}>
              Close
            </Button>
            <Button variant="primary" onClick={this.saveShares}>
              Share
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
};

function mapStateToProps(state) {
  return {
    allUsers: state.Admin.users,
    currentUser: state.Application.currentUser
  };
}

const mapDispatchToProps = {
  getUserAdminInfo,
}

function ShareButton({ children, disabled, id, onClick }) {
  return (
    <a
      id={id}
      className={`eqv-button ${disabled ? 'eqv-disabled' : ''}`}
      onClick={onClick}>
      {children}
    </a>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearchHtml)